import useAxios from "../../hooks/useAxios";

const useSpectatorAccessService = () => {
  const axiosList = useAxios();
  const axiosAdd = useAxios();
  const axiosRemove = useAxios();

  const getAllSpectatorAccesses = async () => {
    await axiosList.fetchData({
      url: `/admin/spectator-access`,
      method: "GET",
    });
  };

  const addSpectatorAccess = async (employeeId, approverPositionId) => {
    return await axiosAdd.fetchData({
      url: `/admin/spectator-access/add`,
      method: "POST",
      data: {
        employee_id: employeeId,
        approver_position_id: approverPositionId,
      },
    });
  };

  const removeSpectatorAccess = async (id) => {
    return await axiosRemove.fetchData({
      url: `/admin/spectator-access/remove/${id}`,
      method: "POST",
    });
  };

  return {
    getAllSpectatorAccesses,
    listLoading: axiosList.loading,
    listResponse: axiosList.response,
    addSpectatorAccess,
    addLoading: axiosAdd.loading,
    removeSpectatorAccess,
    removeLoading: axiosRemove.loading,
  };
};

export default useSpectatorAccessService;
